export const data = [
	{
		title: 'Доставка и оплата',
		link: '/delivery/'
	},
	{
		title: 'Обмен и возврат',
		link: '/return/'
	},
	{
		title: 'Гарантия',
		link: '/guarantee/'
	},
	{
		title: 'Реквизиты',
		link: '/bank-details/'
	},
	{
		title: 'Контакты',
		link: '/contacts/'
	}
]
